interface ScoreBadgeProps {
  score: number
  label?: string
  size?: 'sm' | 'md'
}

function scoreClass(score: number) {
  if (score >= 90) return 'bg-green-500/10 text-green-400 border-green-500/20'
  if (score >= 50) return 'bg-amber-500/10 text-amber-400 border-amber-500/20'
  return 'bg-red-500/10 text-red-400 border-red-500/20'
}

export default function ScoreBadge({ score, label, size = 'md' }: ScoreBadgeProps) {
  const sizeClass = size === 'sm' ? 'text-xs px-1.5 py-0.5' : 'text-sm px-2 py-0.5'

  return (
    <span className={`inline-flex items-center gap-1 rounded border font-medium ${sizeClass} ${scoreClass(score)}`}>
      <span className="font-bold tabular-nums">{score}</span>
      {label && <span className="opacity-70">{label}</span>}
    </span>
  )
}
